/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_ActiveInputs */

const vi_warehouse_position_active = /** @type {(inputs: Warehouse_Position_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dùng`)
};

/**

* @param {Warehouse_Position_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_active = /** @type {((inputs?: Warehouse_Position_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_active(inputs)
});